import { useTranslation } from "react-i18next";
import {useState, useEffect, useRef, useContext} from "react";
import {useDispatch, useSelector} from "react-redux";
import {treeActions} from "../../../redux/slices/treeSlice";
import OverrideRootElement from "../OverrideRootElement";
import TPCheckbox from '../TPCheckbox';
import { FormControl, InputLabel, MenuItem, Select, Stack, TextField, Button } from "@mui/material";
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";

//'Schema Location' - 
// Added the ability to select files from a file browser, but due to fundamental web browser security limitations, 
// I don’t currently know of a way to access the user’s filepath. 
// Until a permanent solution is found, I made it so that when a user selects a file, 
// the text field will display the file name but with a fake path.
// - HC

export default function XMLForm() {
  const { t } = useTranslation();
  const fileBrowser = useRef();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector(state => state.treeData[parentScreen]);
  const dispatch = useDispatch();
  const [validationType, setValidationType] = useState('NONE');
  const [schemaLocation, setSchemaLocation] = useState('');
  const [namespaceDependant, setNamespaceDependant] = useState(false);
  const [trimData, setTrimData] = useState(false);
  const [decodeData, setDecodeData] = useState(false);
  const [preserveNamespace, setPreserveNamespace] = useState(false);

  useEffect(() => {
    const header = rightTree.tree.templateHeader;
    setValidationType(header.VALIDATION_TYPE || 'NONE');
    setNamespaceDependant(header.USE_NAMESPACE ?
      (typeof header.USE_NAMESPACE === 'boolean' && header.USE_NAMESPACE) || header.USE_NAMESPACE === "TRUE" || false
      : false)
    setSchemaLocation(header.FILE_PATH || '');
    setTrimData(
      header.TRIMDATA ?
        (typeof header.TRIMDATA === 'boolean' && header.TRIMDATA) || header.TRIMDATA === "TRUE" || false
        : false
    );
    setDecodeData(
      header.URLDECODE ?
        (typeof header.URLDECODE === 'boolean' && header.URLDECODE) || header.URLDECODE === "TRUE" || false
        : false
    );
    setPreserveNamespace(
      header.PRESERVE_NAMESPACES_WHEN_MAPPING ? 
        (typeof header.PRESERVE_NAMESPACES_WHEN_MAPPING === 'boolean' && header.PRESERVE_NAMESPACES_WHEN_MAPPING) || header.PRESERVE_NAMESPACES_WHEN_MAPPING === "TRUE" || false
        : false
    )
  }, [rightTree.tree.templateHeader])

  const handleChange = (key, value) => {
    dispatch(treeActions.setRightTreeTemplateHeaders({ screen: parentScreen, key, value }));
  }


  return ( parentScreen === 'inbound' &&
    <>
      
        <FormControl size="small" variant="outlined">
          <InputLabel id="validationDropdownLabel">{t('LBL_VALID_TYPE')}</InputLabel>
          <Select
            className="width-100"
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 250
                }
              }
            }}
            labelId="validationDropdownLabel"
            id="validationDropdown"
            value={validationType}
            onChange={(e) => {
              setValidationType(e.target.value);
              handleChange('VALIDATION_TYPE', e.target.value)
            }}
            label={t('LBL_VALID_TYPE')}
          >
            {[
              <MenuItem key={'NONE'} value='NONE'>{t('NONE')}</MenuItem>,
              <MenuItem key={'DTD'} value='DTD'>{t('DTD')}</MenuItem>,
              <MenuItem key={'SCHEMA'} value='SCHEMA'>{t('SCHEMA')}</MenuItem>
            ]}
          </Select>
        </FormControl>
        {
          validationType === 'SCHEMA' ? (
            <div>
              <div className="flex">
                <TextField
                  className="width-100"
                  label={t('LBL_SCHEMA_LOC')} 
                  variant="outlined" 
                  size="small"
                  placeholder=''
                  value={schemaLocation}
                  onChange={(e) => {
                    setSchemaLocation(e.target.value);
                    handleChange('FILE_PATH', e.target.value);
                  }}
                />
                <input 
                    style={{'display': 'none'}} 
                    type="file" 
                    ref={fileBrowser} 
                    onChange={(e) => {
                      setSchemaLocation(e.target.value);
                      handleChange('FILE_PATH', e.target.value)
                    }} 
                  />
                <Button
                  variant="outlined"
                  size="small"
                  disableElevation
                  className='margin-left-4'
                  sx={{
                    width: '40px', 
                    padding: '4px 8px',
                    minWidth: '40px',
                  }}
                  onClick={() =>fileBrowser.current.click()}
                >
                  <DriveFolderUploadIcon fontSize="small"/>
                </Button>
              </div>
              <TPCheckbox 
                label={t('BTN_NAMESPACE_DEPENDANT')}
                checked={namespaceDependant}
                handleCheck={(checked) => {
                  setTrimData(checked);
                  handleChange('USE_NAMESPACE', checked);
                }}
              />
            </div>
          ) : ''
        }
      <div className="flex flex-wrap">
        <TPCheckbox 
          label={t('BTN_TRIM_DATA')}
          checked={trimData}
          handleCheck={(checked) => {
            setTrimData(checked);
            handleChange('TRIMDATA', checked);
          }}
        />
        <TPCheckbox 
          label={t('BTN_URLDECODE_DATA')}
          checked={decodeData}
          handleCheck={(checked) => {
            setDecodeData(checked);
            handleChange('URLDECODE', checked);
          }}
        />
      </div>
      <OverrideRootElement />
      <div className="flex flex-wrap">
        <TPCheckbox 
          label={t('BTN_PRESERVE_NAMESPACES')}
          checked={preserveNamespace}
          handleCheck={(checked) => {
            setPreserveNamespace(checked);
            handleChange('PRESERVE_NAMESPACES_WHEN_MAPPING', checked);
          }}
        />
      </div>
    </>
  )
}
